var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-col",
    {
      attrs: {
        cols: "12"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" Create Repository ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-form",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c("v-switch", {
                            attrs: {
                              label: "Clone a Repository",
                              hint:
                                "Enable this toggle if you want to clone a remote repository, or disable this toggle to create a new repository. ",
                              "persistent-hint": ""
                            },
                            model: {
                              value: _vm.clone,
                              callback: function callback($$v) {
                                _vm.clone = $$v
                              },
                              expression: "clone"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.clone
                        ? _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("gg-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: "Clone URL",
                                  hint:
                                    "Enter the clone URL for the remote repository. All clone URLs must begin with the http://, https://, ssh://, or git:// protocols or begin with a username and domain.",
                                  "persistent-hint": "",
                                  name: "clone-url",
                                  "data-vv-as": "Clone url",
                                  "error-messages": _vm.errors.collect(
                                    "clone-url"
                                  )
                                },
                                model: {
                                  value: _vm.model.cloneUrl,
                                  callback: function callback($$v) {
                                    _vm.$set(_vm.model, "cloneUrl", $$v)
                                  },
                                  expression: "model.cloneUrl"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c("gg-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              label: "Repository Path",
                              hint:
                                "Enter the desired path for the repository’s directory. If you enter a path that does not exist, the system will create the directory when it creates or clones the repository. ",
                              "persistent-hint": "",
                              prefix: _vm.rootPath,
                              name: "repository-path",
                              "data-vv-as": "Repository path",
                              "error-messages": _vm.errors.collect(
                                "repository-path"
                              )
                            },
                            model: {
                              value: _vm.model.repository_path,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "repository_path", $$v)
                              },
                              expression: "model.repository_path"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c("gg-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              label: "Repository Name",
                              hint:
                                "This name does not impact functionality, and instead functions only as a display name. ",
                              "persistent-hint": "",
                              name: "repository-name",
                              "data-vv-as": "Repository name",
                              "error-messages": _vm.errors.collect(
                                "repository-name"
                              )
                            },
                            model: {
                              value: _vm.model.name,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "name", $$v)
                              },
                              expression: "model.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            loading: _vm.loading,
                            disabled: _vm.loading
                          },
                          on: {
                            click: _vm.createRepository
                          }
                        },
                        [_vm._v(" Create repository ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }